import { useNotify } from '@globaleris/ui.library'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  EnumTipoAgrupacion,
  EnumTipoCicloFacturacion,
  EnumTipoFacturacion,
  EnumTipoRefacturacion,
  EnumTipoSujeto
} from '../../../api'
import { cfExecutionPatchRequestModel } from '../../../api/Argentia/endpoints/invoiceCyclesExecutions/model/cfExecutionModel'
import { EnumEstadoCiclo } from '../../../api/oData/enums/enumEstadoCiclo'
import { NonAuthRoutes } from '../../../model'
import { updateInvoiceCycleExecution } from '../../invoiceCycles/invoiceCycles.service'

interface NavigateToSettlementsInvoicesParams {
  executionCycleId: number
  invoiceCycleId?: number
  invoiceCycleType?: EnumTipoCicloFacturacion
  subjectType?: EnumTipoSujeto
  billingType?: EnumTipoFacturacion
  isFinishedExecutionCycle?: boolean
  reInvoiceType?: EnumTipoRefacturacion
  groupingType?: EnumTipoAgrupacion
}

/**
 * Hook que maneja la navegación a la página de SettlementsInvoices
 * con actualización del estado del ciclo a PdteValidarFacturas
 *
 * @returns Función navigateToSettlementsInvoices para navegar a la página
 */
export const useNavigateToSettlementsInvoices = () => {
  const history = useHistory()
  const [t] = useTranslation(['settlements'])
  const { error } = useNotify()

  const navigateToSettlementsInvoices = async (params: NavigateToSettlementsInvoicesParams) => {
    const request: cfExecutionPatchRequestModel = {
      cycleStatus: EnumEstadoCiclo.PdteValidarFacturas
    }

    const response = await updateInvoiceCycleExecution(params.executionCycleId, request)

    if (!response.success) {
      error(t('settlements:fetchResponse.updateExecutionCycle.error'))
      return
    }

    history.push(NonAuthRoutes.SettlementsInvoices, {
      executionCycleId: params.executionCycleId,
      invoiceCycleId: params.invoiceCycleId,
      invoiceCycleType: params.invoiceCycleType,
      subjectType: params.subjectType,
      billingType: params.billingType,
      finishedExecutionCycle: params.isFinishedExecutionCycle,
      reInvoiceType: params.reInvoiceType,
      groupingType: params.groupingType
    })
  }

  return { navigateToSettlementsInvoices }
}
